import CustomizeFontSizes from "../../../../partials/customizing/font-sizes.mdx";
import * as React from 'react';
export default {
  CustomizeFontSizes,
  React
};